import Vue from 'vue'
import Router from 'vue-router'

// import App from './App'
import Form from './form'
import Designer from './designer'

const routes = [{
	path: '/',
	component: Form,
	name: 'form'
}, {
	path: '/designer',
	component: Designer,
	name: 'designer'
}]

const router = new Router({
	mode: 'history',
	routes: routes
})

Vue.use(Router)

export default router
